export default __webpack_public_path__ + "static/media/products-3-m.e4592466.webp";